<div class="divider-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'common.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <span>{{ 'common.the-search-returned' | translate | ucfirst }}</span>
    &nbsp;
    <span class="f-wb">{{ searchResult.TotalCount }}</span>
    &nbsp;
    <span class="f-wb">{{ 'coupons.search.coupons' | translate }}</span>
  </ng-template>
  <button pButton type="button" class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
    <i class="large-icon pi pi-times"></i>
    <span>{{ 'common.clear-search' | translate | uppercase }}</span>
  </button>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    [lazy]="true"
    (onLazyLoad)="lazyLoad($event)"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ProfileReportName">
          {{ 'coupons.search.profile' | translate | ucfirst }}
          <p-sortIcon field="ProfileReportName"></p-sortIcon>
        </th>
        <th pSortableColumn="Title">
          {{ 'coupons.search.coupon-title' | translate | ucfirst }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th pSortableColumn="CouponTypeName">
          {{ 'coupons.search.coupon-type' | translate | ucfirst }}
          <p-sortIcon field="CouponTypeName"></p-sortIcon>
        </th>
        <th pSortableColumn="Expires" [style]="{ width: '120px' }">
          {{ 'coupons.search.expires' | translate | ucfirst }}
          <p-sortIcon field="Expires"></p-sortIcon>
        </th>
        <th pSortableColumn="Approved" [style]="{ width: '120px' }">
          {{ 'coupons.search.approved' | translate | ucfirst }}
          <p-sortIcon field="Approved"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-coupon>
      <tr>
        <td>
          <a [routerLink]="['/profile', coupon.ProfileId]"> {{ coupon.Profile?.ReportName }} ({{ coupon.ProfileId }}) </a>
        </td>
        <td>{{ coupon.Title }}</td>
        <td>{{ coupon.CouponType?.CouponType1 }}</td>
        <td class="t-ac">{{ coupon.Expires | date: 'MM/dd/yyyy' }}</td>
        <td class="t-ac">
          <p-checkbox binary="true" [(ngModel)]="coupon.Approved" (onChange)="couponChanged(coupon)"></p-checkbox>
        </td>
        <td class="t-ac">
          <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForCoupon(coupon)"> </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>

<p-confirmDialog
  #cd
  key="deleteCouponCD"
  header="{{ 'coupons.search.confirm-delete-header' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
